import { TypographyOptions } from '@mui/material/styles/createTypography';

const typography: TypographyOptions = {
  fontFamily: [
    'Source Sans Pro',
    'Poppins',
    'sans-serif',
    'Inter',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  fontSize: 13,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '52px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  h2: {
    fontSize: 28,
    fontWeight: 600,
    lineHeight: '42px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  h3: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: '28px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  h4: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '24px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  h5: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '24px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  h6: {
    fontSize: 17,
    fontWeight: 600,
    lineHeight: '20px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  body1: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '21px',
    letterSpacing: 0.1,
    color: 'rgba(0, 0, 0, 0.87)',
  },
  subtitle1: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '22px',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  body2: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    letterSpacing: 0.1,
    color: 'rgba(0, 0, 0, 0.87)',
  },
  subtitle2: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '21px',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  caption: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    letterSpacing: 0.3,
    color: 'rgba(0, 0, 0, 0.87)',
  },
  overline: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: 0.3,
    color: 'rgba(0, 0, 0, 0.87)',
  },
  button: {
    textTransform: 'uppercase',
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: 1,
    padding: '8px 16px',
  },
};

export default typography;
